import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        setShowUpdate(true);
      });
    }
  }, []);

  const handleUpdate = () => {
    window.location.reload();
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-blue-500 text-white p-4 rounded-xl shadow-lg z-50 max-w-sm">
      <div className="flex items-center gap-3">
        <RefreshCw className="w-5 h-5" />
        <div className="flex-1">
          <p className="font-semibold">Update Available</p>
          <p className="text-sm opacity-90">A new version is ready</p>
        </div>
        <button
          onClick={handleUpdate}
          className="px-4 py-2 bg-white text-blue-500 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
        >
          Reload
        </button>
      </div>
    </div>
  );
};

export default UpdateNotification;